(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(e){if(e.target.matches('[data-variant]')){const parent=e.target.closest('[data-product]');if(parent)parent.querySelector('[data-price]').textContent=e.target.selectedOptions[0].dataset.price;}});document.addEventListener('change',function(e){if(!e.target.matches('[data-catalog-variant]'))return;const root=e.target.closest('[data-catalog-product]');const selected=e.target.selectedOptions[0];const button=root.querySelector('[data-catalog-add]');root.querySelector('[data-catalog-price]').textContent=selected.dataset.price;button.disabled=selected.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);history.replaceState({},'',url);});
  } catch(e) { console.error(e); }
})();
})();
